<h6 i18n>Which template will be sent?</h6>
<div class="d-flex gap-3">
  <mat-form-field2 class="mat-block">
    <app-select
      [items]="templates$ | async"
      [formControl]="form.get('template')"
      i18n-matTooltip
      matTooltip="Select a template to be sent with this automation. Only templates with a guest, a user, or both a guest and user as signers will be available for use with this automation."
      bindValue="template_id"
      bindLabel="name"
      i18n-placeholder
      placeholder="Select Template"
      [required]="true"
    >
    </app-select>
    <mat-error *ngIf="form.get('template').touched && form.get('template').hasError('required')" i18n>
      Template is required
    </mat-error>
  </mat-form-field2>
  <button class="btn btn-secondary-light align-input-row-end" *ngIf="templateCtrl.value" (click)="onEdit()">
    <i class="cs-icon cs-icon-pencil"></i>
  </button>
  <button class="btn btn-secondary-info align-input-row-end" (click)="onAdd()">
    <i class="far fa-plus"></i>
  </button>
</div>

<ng-container *ngIf="template">
  <h6 i18n>Who will send and/or sign this template?</h6>
  <div class="mb-3" *ngIf="hasGuestRole | call : template?.roles">
    <mat-checkbox
      [disabled]="true"
      [formControl]="form.get('guest')"
      i18n-matTooltip
      matTooltip="This option is automatically checked if there is a guest listed as a signer on the template."
      i18n
    >
      Send to Guest
    </mat-checkbox>
  </div>
  <ng-container *ngIf="getUserRoles | call : template?.roles as roles">
    <ng-container *ngFor="let ctrl of signersCtrl.controls; let i = index">
      <mat-form-field2 class="mat-block" [hidePlaceholder]="true">
        <mat-label><ng-container i18n>Select Signer for Role</ng-container>: {{ roles[i] }}</mat-label>
        <app-select
          [formControl]="ctrl"
          [items]="users$ | async"
          bindLabel="name"
          bindValue="id"
          [searchable]="true"
          [required]="true"
        >
          <ng-template selectItem let-item="item">
            <div>
              {{ item.name }} <span class="text-muted">({{ item.primaryEmail }})</span>
            </div>
          </ng-template>
        </app-select>
        <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')" i18n>User is required</mat-error>
      </mat-form-field2>
    </ng-container>
  </ng-container>
</ng-container>
